"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var spacing = _tokens.default.spacing;

var BrandIconSchool = function BrandIconSchool(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var sizeArray = Object.entries(spacing.icons);
  var sizeOptions = new Map(sizeArray);
  var displaySize = sizeOptions.get(props.size);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: props.color && displayColor,
    "aria-hidden": !title,
    role: title ? "img" : null,
    width: props.size && displaySize,
    height: props.size && displaySize,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".School_svg__cls-1{fill:#002664}")), /*#__PURE__*/React.createElement("path", {
    className: "School_svg__cls-1",
    d: "M27 38h-6a1 1 0 00-1 1v9h2v-8h4v8h2v-9a1 1 0 00-1-1zM11.47 19.88L24 13.14l12.53 6.74a1 1 0 00.94-1.76L25 11.4V8.62l7.45-3.73A1 1 0 0033 4a1 1 0 00-.65-.89l-8-3A1 1 0 0023 1v10.4l-12.47 6.72a1 1 0 10.94 1.76zM25 2.44l4.5 1.69L25 6.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "School_svg__cls-1",
    d: "M13.99 20h2v28h-2zM4 34h2v14H4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "School_svg__cls-1",
    d: "M0 26v5a1 1 0 001 1h13v-2H2v-3h12v-2H1a1 1 0 00-1 1zm9 10h2v4H9zm0 6h2v4H9zm38-17H34v-5h-2v28h2V31.94h13a1 1 0 001-1V26a1 1 0 00-1-1zm-1 5H34v-3h12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "School_svg__cls-1",
    d: "M37 36.02h2V40h-2zM37 42h2v4h-2zm5-8h2v14h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 27,
    r: 5,
    fill: "#d7153a"
  }));
};

BrandIconSchool.propTypes = {
  title: _propTypes.default.string,
  titleId: _propTypes.default.string,
  size: _propTypes.default.oneOf(["lg", "xl", "xxl"])
};
BrandIconSchool.defaultProps = {
  size: "xl",
  focusable: !1
};
var _default = BrandIconSchool;
exports.default = _default;